module.exports = __webpack_public_path__ + "img/1_007.70f75367.jpg";